/* eslint-disable quote-props */
import React from 'react';

export const IconSmallCrown: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <g fill="#000">
            <path d="M6.198 7.717l2.74 2.783 2.252-4.413a1 1 0 111.62 0l2.252 4.413 2.74-2.783a1 1 0 111.046.221L18 16H6l-.849-8.062a1 1 0 111.047-.221zM15.5 19.5A2.5 2.5 0 0018 17H6a2.5 2.5 0 002.5 2.5h7z" />
        </g>
    </svg>
);
